import { render, staticRenderFns } from "./TransactionsDetail.vue?vue&type=template&id=39e855f1&scoped=true&"
import script from "./TransactionsDetail.vue?vue&type=script&lang=ts&"
export * from "./TransactionsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionsDetail.vue?vue&type=style&index=0&id=39e855f1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e855f1",
  null
  
)

export default component.exports